import { z } from 'zod'
import { Model } from './architecture'

export const RatingValidation = z.object({
  value: z.number({ required_error: '[Rating] value is required' }).min(0).max(10),
})

export class Rating extends Model {
  static create({ value }: z.infer<typeof RatingValidation>) {
    RatingValidation.parse({ value })
    return new Rating(value)
  }

  static empty() {
    return new Rating()
  }

  static createOrNull({ value }: { value?: number | string | null }) {
    if (value === undefined || value === null) {
      return null
    }
    try {
      const rating = parseFloat(value.toString())
      return Rating.create({ value: rating })
    } catch {
      return null
    }
  }

  constructor(readonly value?: number) {
    super()
  }

  get rating() {
    return this.value
  }

  hasRating(): this is Rating & z.infer<typeof RatingValidation> {
    return this.value !== undefined
  }

  toJSON() {
    return { value: this.value }
  }
}
